import { makeStyles } from "@material-ui/core/styles";

export const stylePublicVac = makeStyles((theme) => ({
    container: {
        display: 'flex',
        width: '100%',
        flexDirection: 'column'
    },
    containerOne: {
        display: 'flex',
        width: '100%',
        height: '50px',
        background: '#4D8D9D',
        alignItems: 'center'
    },
    containerTwo: {
        display: 'flex',
        width: '100%',
        height: '102px',
        background: '#fff',
        alignItems: 'end',
        marginBottom: '50px',
    },
    titleVacancies:{
        fontSize: '20px',
        marginLeft: '80px',
        color: '#7EBDCE',
        margin: '0 0 15px 0'
    },
    containerBody: {
        margin: '0px 50px'
    },
    containerSearch: {
        marginBottom: '30px'
    },
    inputForm: {
        backgroundColor: "#FFFFFF",
        boxSizing: "border-box",
        borderRadius: "8px",
        height: 40,
        fontSize: "14px",
        [`& fieldset`]: {
        borderRadius: 8,
        fontSize: 14,
        },
    },
    menuItem: {
        "&:hover": {
          borderLeft: "4px solid #098B8B",
        },
    },
    buttonSearch: {
        marginRight: "10px",
        color: "#ffffff",
        background: "#7EBDCE",
        "&:hover": { color: "white", background: "#099F9F" },
    },
    divAccordion: {
        width: '100%',
        marginTop: '10px',
    },
    column: {
        flexBasis: "39.6%",
        paddingLeft: '25px',
        marginRight: 10,
    },
    heading: {
        fontSize: theme.typography.pxToRem(12),
        wordBreak: 'normal',
    },
    secondaryHeading: {
        fontSize: theme.typography.pxToRem(12),
        color: theme.palette.text.secondary,
        wordBreak: 'normal'
    },
    columnEvent: {
        flexBasis: "5%",
        display: "flex",
        alignItems: "center"
    },
    iconEvent: {
        color: "#666666",
        cursor: "pointer",
        height: 18,
        width: 18,
    },
    columnBtn: {
        flexBasis: "30%",
        display: "flex",
        alignItems: "center",
    }
}));
